/* eslint-disable no-useless-concat */
import React from 'react'

export default function FormattedObject({ name, scale }) {
	if (!scale) return

	return (
		<pre>
			{`${name}: { `}
			{scale.map((color) => {
						let key = scale.indexOf(color)
						if (key === 0) {
							return '\n' + `  50: '${color}', ` + '\n'
						} else {
							key = key * 100
							return `  ${key}: '${color}', ` + '\n'
						}
				  })}
			{'}'}
		</pre>
	)
}
